import React, { useState } from "react";
import useIsMobile from "../hooks/useIsMobile";

function FlipCard({ coverImage, name, url, grievanceURL, pp, tc }) {
  const [flipped, setFlipped] = useState(false);
  const isMobile = useIsMobile();

  const handleInteraction = () => {
    if (isMobile) {
      setFlipped(!flipped);
    }
  };

  const renderFrontSide = (coverImage) => {
    return (
      <div className="lending-partner-section-front">
        <img
          src={coverImage}
          alt="Lending Partner Logo"
          className="lending-partner-section-logo"
        />
      </div>
    );
  };

  const renderBackSide = (name, url, grievanceURL, pp, tc) => {
    return (
      <div className="lending-partner-section-back">
        <div className="lending-partner-section-back-content">
        <div>
          <strong>Lender: </strong>
          {name}
        </div>
        <div>
          <strong>URL: </strong>
          <a href={url} target="_blank" rel="noopener noreferrer">
            {url}
          </a>
        </div>
        <div>
          <strong>Grievance: </strong>
          <a href={grievanceURL} target="_blank" rel="noopener noreferrer">
            {grievanceURL}
          </a>
        </div>
        <div>
          <a href={pp} target="_blank" rel="noopener noreferrer">
            Privacy Policy
          </a>
          {" and "}
          <a href={tc} target="_blank" rel="noopener noreferrer">
            Terms & Conditions
          </a>
        </div>
        </div>
      </div>
    );
  };

  return (
    <div
      className="lending-partner-section-card"
      onClick={handleInteraction}
      onMouseEnter={() => !isMobile && setFlipped(true)}
      onMouseLeave={() => !isMobile && setFlipped(false)}
    >
      {isMobile && (
        <div className="lending-partner-section-indicator">Tap</div>
      )}
      <div className={`lending-partner-section-inner ${flipped ? "flipped" : ""}`}>
        {renderFrontSide(coverImage)}
        {renderBackSide(name, url, grievanceURL, pp, tc)}
      </div>
    </div>
  );
}

export default React.memo(FlipCard);
